import React, {Component} from 'react';
import * as customers from 'customers/actions/customers';
import {connect} from 'react-redux';
import {DetailContainer} from 'customers/DetailContainer';
import autobind from 'autobind-decorator';
import ContactTable from 'customers/contacts/ContactTable';
import Loading from 'apa/components/Loading';

@connect(
    state => {
        return {
            customers: state.customers
        }
    },
    dispatch => {
        return {
            fetchCustomer: (customer_id, callback) => {
                dispatch(customers.fetchCustomer(customer_id, callback))
            }
        }
    }
)
export default class ContactList extends Component {


    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            customer: null
        };
    }

    componentDidMount() {
        this.fetchCustomer()
    }

    @autobind
    fetchCustomer() {
        const id = this.props.match.params.id;
        this.props.fetchCustomer(id, customer =>
            this.setState(
                {
                    isLoading: false,
                    customer: customer
                }
            ))
    }

    render() {
        const id = this.props.match.params.id;
        const customer = this.state.customer;
        if (this.state.isLoading)
            return <Loading/>;
        return (
            <DetailContainer id={id}>
                <h1>{customer.name}</h1>
                <ContactTable addButton customer={id} contacts={customer.contacts}/>
            </DetailContainer>
        )
    }
}

